



















































































































import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import RencanaKontrol from "@/services/RencanaKontrol";
import { RencanaKontrolRow } from "@/types/rencanaKontrol";
import { tglAngka } from "@/utils/rencanaKontrol";
import { appModule } from "@/store/modules/app";

@Component
export default class DialogSyncSrk extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ type: Object, default: null }) readonly item!: RencanaKontrolRow | null;

  loading = false;

  /** Hasil sinkronisasi terakhir di dialog ini; null = belum dikirim. */
  hasilBerhasil: boolean | null = null;

  hasilPesan = "";

  @Watch("value")
  onBuka(val: boolean) {
    if (val) {
      this.hasilBerhasil = null;
      this.hasilPesan = "";
    }
  }

  get judulPesan(): string {
    if (this.hasilBerhasil === null) return "Gagal pada sinkronisasi sebelumnya";

    return this.hasilBerhasil ? "Sinkronisasi berhasil" : "Sinkronisasi gagal";
  }

  get pesanTampil(): string {
    if (this.hasilBerhasil !== null) return this.hasilPesan;

    return this.item && this.item.status_srk === "gagal"
      ? this.item.status_pesan || ""
      : "";
  }

  tglAngka(iso: string | null): string {
    return tglAngka(iso);
  }

  tutup() {
    if (this.loading) return;

    this.$emit("input", false);
  }

  async sinkronkan() {
    if (!this.item || this.loading) return;

    this.loading = true;

    try {
      const resp = await RencanaKontrol.syncSrk(this.item.id);
      const berhasil = resp.status === 1;

      this.hasilBerhasil = berhasil;
      this.hasilPesan = resp.message || "";

      if (berhasil) {
        appModule.sendSuccessNotice(resp.message || "SRK berhasil diterbitkan.");
      }

      this.$emit("tersinkron", { row: resp.data, berhasil });
    } catch {
      this.hasilBerhasil = null;
    } finally {
      this.loading = false;
    }
  }
}
